import log from 'salvo-lite/log'
import GeoService from '@eastsideco/escshopify/src/plugins/geoservice/GeoService.js'

class GEOIP {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._geoip = elem.getAtt
        this._geoService = null
        this._geoInfo = null
        this._options = Object.assign({ redirections: {} }, JSON.parse(elem.getAttribute('data-geoip') || '{}'))

        log.debug(this.constructor.name, 'Constructed', this)
    }

    async onInit () {
        this._geoService = new GeoService()
        this._geoInfo = await this._geoService.lookupGeo()
        this._subdivisions = this._geoInfo.subdivisions

        let countryISO = this._geoInfo.country.iso_code
        let current = this._options.redirections[countryISO]

        if (current) {
            console.log(current)
        }
    }
}

export default GEOIP



// WEBPACK FOOTER //
// ./src/resources/scripts/components/GEOIP.js